import IconHeader from '../TableCells/IconHeader/IconHeader'

export const employeeManagementColumns = [
  {
    Header: 'Ver información',
    accessor: 'info',
    type: 'clickeable',
  },
  {
    Header: IconHeader,
    label: 'RUT',
    accessor: 'sRUT',
    type: 'dni',
    sortBy: 'RUT',
  },
  {
    label: 'Nombre',
    Header: IconHeader,
    accessor: 'sNombre',
    sortBy: 'NOMBRE',
  },
  {
    Header: 'Estado',
    accessor: 'sEstado',
    type: 'status',
  },
  {
    Header: 'Centro de costo',
    accessor: 'CentroCosto',
  },
  {
    Header: 'Sucursal',
    accessor: 'Sucursal',
  },
  {
    Header: 'Grupos',
    accessor: 'sGrupo',
  },
]
